import React from 'react'
import { graphql } from 'gatsby'
import { BuilderComponent } from '@builder.io/react'

export const pageQuery = graphql`
	query ($path: String!) {
		allBuilderModels {
			oneBfdPage(target: { urlPath: $path }, options: { cachebust: true }) {
				content
				data { 
					title
				}
			}
		}
	}
`

export const Head = (props) => {
	const models = props.data?.allBuilderModels
	const title = models?.oneBfdPage?.data.title
	return (
		<>
			<title>{title}</title>
		</>
	)
}

export default function BuilderIOPage(props) {
	const models = props.data?.allBuilderModels
	const page = models?.oneBfdPage?.content
	return <BuilderComponent model="bfd-page" content={page} />
}
